import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs';
import BaiduMap from 'vue-baidu-map';


import {
   Input,
   Pagination,
   Button,
   Select,
   Option,
   Radio,
   RadioGroup,
   RadioButton,
   Message,
   Dialog
} from 'element-ui';

Vue.use(Input);
Vue.use(Pagination);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Message);
Vue.use(Dialog);
Vue.prototype.$message = Message;
Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: 'jeaQnWKFtMiwSbQXI4zgnAIrtD4O7GpH'
})

Vue.config.productionTip = false
// Vue.prototype.$uploadurl = 'http://api.zyapplet.com'//本地
Vue.prototype.$uploadurl = 'https://api.zsone.net'//线上
Vue.prototype.$http = axios
Vue.prototype.$qs = qs

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
 
  config.headers.Token = localStorage.getItem("token")
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

//http reponse响应拦截器
axios.interceptors.response.use(
  response =>{
    return response;
  },
  error=>{
    if(error.response){
      switch(error.response.status){
        case 401:
          localStorage.removeItem('token');
          router.replace({
            path: '/login',
            // query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
          })
      }
    }
  })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
